import {Injectable} from '@angular/core';
import {Settings} from '@shared/store/shared-state';

@Injectable({
  providedIn: 'root'
})
export class SyncSettingsService {

  private settings: Settings = {
    agrocasco: null,
    autoclaimsCrops: null,
    googleReCaptchaSiteKey: null,
    serverNode: null,
    autoclaimsUrl: null,
    documents: {},
    brand: null,
    claimsEmail: null,
    enabledFeatures: [],
    concordiaClaims: null,
    reportClaimUrls: null
  };

  get(): Settings {
    return this.settings;
  }

  update(settings: Settings) {
    this.settings = settings;
  }

}
